export const SYNC_MEZZO_ERRORS_OPTIONS = '@@mezzoErrors/sync'
